import PropTypes from 'prop-types';
import React from 'react';
import { Theme } from '@spoiler-alert/ui-library';
import { createUseStyles } from 'react-jss';
import { HashRouter, NavLink, Route, Switch } from 'react-router-dom';

const useStyles = createUseStyles({
  wrap: {
    position: 'relative',
  },
  paneSelection: {
    display: 'flex',
    fontSize: 16,
    margin: [15, 0, 0],
    gap: 10,
  },
  link: {
    display: 'block',
    padding: [10, 20],
    border: `2px solid ${Theme.mauve80}`,
    cursor: 'pointer',
    color: Theme.mauveDark,
    borderBottomWidth: 0,
    '&:hover': {
      background: Theme.mauve10,
    },
  },
  activeLink: {
    background: Theme.mauve30,
    '&:hover': {
      background: Theme.mauve30,
    },
  },
  content: {
    border: `2px solid ${Theme.mauve80}`,
  },
});

const Tabs = ({ panes, ...args }) => {
  const classes = useStyles();

  return (
    <HashRouter hashType={'noslash'}>
      <div className={classes.wrap}>
        <div className={classes.paneSelection}>
          {panes.map(({ path, label }) => (
            <NavLink key={path} exact to={`/${path}`} className={classes.link} activeClassName={classes.activeLink}>
              {label}
            </NavLink>
          ))}
        </div>
        <div className={classes.content}>
          <Switch>
            {panes.map(({ path, Component }) => (
              <Route exact key={path} path={`/${path}`}>
                <Component {...args} />
              </Route>
            ))}
          </Switch>
        </div>
      </div>
    </HashRouter>
  );
};

Tabs.propTypes = {
  panes: PropTypes.arrayOf(
    PropTypes.shape({
      Component: PropTypes.elementType.isRequired,
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    }),
  ),
};

export default Tabs;
